// extracted by mini-css-extract-plugin
export default {"contact_form_section_container":"contact-form-section_contact_form_section_container__TN0Ko"};